import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const updateStationsPriceSettingsUpdatingStatus = (
  state: StationsState,
  action: PayloadAction<StationsState['stationsPriceReportSettings']['updatingStatus']>
) => {
  state.stationsPriceReportSettings.updatingStatus = action.payload
};
